var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"iconfont icon-zanwu meiyoushuju"}),_c('div',{staticClass:"txt"},[_vm._v("暂无数据")])])])
}]

export { render, staticRenderFns }